import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatNumber, NumberFormatOptions } from '@progress/kendo-angular-intl';

@Pipe({
    name: 'kendoFormat',
    standalone: true
})
export class KendoFormatPipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private locale: string) {}
    /**
     * Transforms a number into a formatted string using Kendo's formatNumber function.
     * @param value The number to format.
     * @param format The Kendo numeric format string (e.g., 'n2', '#.##') or a NumberFormatOptions object.
     * @param locale Optional locale string (e.g., 'hr', 'en').
     * @returns The formatted number as a string.
     */
    transform(value: number | null | undefined, format: string | NumberFormatOptions, locale?: string): string {
        if (value == null) {
            return '';
        }

        try {
            return formatNumber(value, format, locale || this.locale);
        } catch (error) {
            console.error(`Error formatting number: ${value} with format: ${JSON.stringify(format)}`, error);
            return value.toString();
        }
    }
}